export const environment = {
    production: false,
    panel: "parkerexch_",
    // domain: "jarvisexch.com",
    // baseUrl: "https://jarvisexch.com",
    domain: "2023exch.com",
    baseUrl: "https://api.2023exch.com",
    // domain: "parker777.io",
    // baseUrl: "https://api.parker777.io",
    pollers: {
        oddsData: 600,
        listOddsData: 10000,
        scoresData: 1000,
    },
    isMobile: true,
    trafficTag: '',
    noDataMsg: 'No Data Found',
    wpLinkShowPages: '/sports, /dashboard, /home, /casino',
    demoLoginUserName: 'demo123',
    imgPrefix: '/parkerexch_client',
    guestEnable: false,
    darkMode: false,
    horseRaceJockeyImgPrefix: 'https://content-cache.cdnbf.net/feeds_images/Horses/SilkColours/',
    stakes: { "stake_name_1": "100", "stake_name_2": "5000", "stake_name_3": "500", "stake_name_4": "25000", "stake_name_5": "50000", "stake_name_6": "100000", "stake_name_7": "500000", "stake_name_8": "1000000", "stake_amount_1": 100, "stake_amount_2": 5000, "stake_amount_3": 500, "stake_amount_4": 25000, "stake_amount_5": 50000, "stake_amount_6": 100000, "stake_amount_7": 500000, "stake_amount_8": 1000000 },
    desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr1-min.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr2-min.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr3-min.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr4-min.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr5-min.png'],
    mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr1-min.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr2-min.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr3-min.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr4-min.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr5-min.png'],
    host: {
        domain: '',
        name: '',
        dName: '',
        ext: '',
        theme: '',
        email: '',
        pusher: {
            key: '',
            cluster: ''
        },
        social: {
            isShow: false,
            facebook: '#',
            whatsapp: '#',
            telegram: '#',
            instagram: '#',
        },
        themePath: [''],
        guestEnable: false,
        ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
        afLoginRedirectUrl: '',
        newHomePage: false,
        isCustomBanner: false,
        demoLogin: false,
        signUpActive: false,
        iframeDomainUrl: '',
        downloadApk: '',
        isAlternateTv: false,
        whatsapp: '',
    },
    hosts: [
        {
            domain: 'localhost',
            name: 'localhost',
            dName: 'LocalHost',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Saffron77Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'parker777.io',
            name: 'parker777io',
            dName: 'parker777',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: '',
                telegram: 'https://t.me/parkerexch_official',
                instagram: 'https://www.instagram.com/parker777.official?igsh=N3V3N2xyaWV0ZmR1',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'parker777.us',
            name: 'parker777io',
            dName: 'parker777',
            ext: '.us',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: '',
                telegram: 'https://t.me/parkerexch_official',
                instagram: 'https://www.instagram.com/parker777.official?igsh=N3V3N2xyaWV0ZmR1',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'parker777.ai',
            name: 'parker777io',
            dName: 'parker777',
            ext: '.ai',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: '',
                telegram: 'https://t.me/parkerexch_official',
                instagram: 'https://www.instagram.com/parker777.official?igsh=N3V3N2xyaWV0ZmR1',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'parker777.vip',
            name: 'parker777io',
            dName: 'parker777',
            ext: '.vip',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: '',
                telegram: 'https://t.me/parkerexch_official',
                instagram: 'https://www.instagram.com/parker777.official?igsh=N3V3N2xyaWV0ZmR1',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'saffron77exch.com',
            name: 'saffron77exch',
            dName: 'saffron77exch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-saffron77exch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Saffron77Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'betfast.games',
            name: 'betfast',
            dName: 'betfast',
            ext: '.games',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-betfast.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/BetFast.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'betfast9.co',
            name: 'betfast9',
            dName: 'betfast9',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-betfast.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/BetFast.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'sportsbar11.games',
            name: 'sportsbar11',
            dName: 'sportsbar11',
            ext: '.games',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-sportsbar11.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/SportsBar11.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'rolex9.games',
            name: 'rolex9',
            dName: 'rolex9',
            ext: '.games',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-rolex9.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Rolex9.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'tiger9exch.in',
            name: 'tiger9exch',
            dName: 'tiger9exch',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-tiger9exch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Tiger9Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'starparker.in',
            name: 'starparker',
            dName: 'starparker',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-starparker.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/StarParker.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'starparker.co',
            name: 'starparker',
            dName: 'starparker',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-starparker.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/StarParker.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'play11.co',
            name: 'play11',
            dName: 'play11',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-play11.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Play11.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'play11.io',
            name: 'play11',
            dName: 'play11',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-play11.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Play11.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'mahakal9.in',
            name: 'mahakal9',
            dName: 'mahakal9',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-mahakal9.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Mahakal9.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'empireexch.in',
            name: 'empireexch',
            dName: 'empireexch',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-empireexch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/EmpireExch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'empireexch.com',
            name: 'empireexch',
            dName: 'empireexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-empireexch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/EmpireExch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'balajiexch99.com',
            name: 'balajiexch99',
            dName: 'balajiexch99',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-balajiexch99.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'balajionline777.com',
            name: 'balajionline777',
            dName: 'balajionline777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-balajionline777.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/BalajiOnline777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'balajionline777.co',
            name: 'balajionline777',
            dName: 'balajionline777',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-balajionline777.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/BalajiOnline777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'jannatexch999.com',
            name: 'jannatexch999',
            dName: 'jannatexch999',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-jannatexch999.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/JannatExch999.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'bigbet99exch.com',
            name: 'bigbet99exch',
            dName: 'bigbet99exch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-bigbet99exch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/BigBet99Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'bigbee777.com',
            name: 'bigbee777',
            dName: 'bigbee777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-bigbee777.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/BigBee777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'garuda555.co',
            name: 'garuda555',
            dName: 'garuda555',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-garuda555.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Garuda555.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'fbcexch.com',
            name: 'fbcexch',
            dName: 'fbcexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-fbc365exch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Fbc365Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'fbc365exch.com',
            name: 'fbc365exch',
            dName: 'fbc365exch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-fbc365exch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Fbc365Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'gamefair247.com',
            name: 'gamefair247',
            dName: 'gamefair247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-gamefair.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/GameFair247.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'playnwin555.co',
            name: 'playnwin555',
            dName: 'playnwin555',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-playwin555.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/PlayNWin555.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'play365exch.in',
            name: 'play365exch',
            dName: 'play365exch',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-play365exch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Play365Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'phoenixexch.in',
            name: 'phoenixexch',
            dName: 'phoenixexch',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-phoenixexch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/PhoenixExch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'phoenixexch.co',
            name: 'phoenixexch',
            dName: 'phoenixexch',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-phoenixexch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/PhoenixExch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'lucky99exch.com',
            name: 'lucky99exch',
            dName: 'lucky99exch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Lucky99Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'lucky99exch.co',
            name: 'lucky99exch',
            dName: 'lucky99exch',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Lucky99Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'khelahobe.org',
            name: 'khelahobe',
            dName: 'khelahobe',
            ext: '.org',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-khelahobe.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'lotusbook777.io',
            name: 'lotusbook777',
            dName: 'lotusbook777',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-lotusbook777.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'lotusbook777.co',
            name: 'lotusbook777',
            dName: 'lotusbook777',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-lotusbook777.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'dreamexch99.com',
            name: 'dreamexch99',
            dName: 'dreamexch99',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-dreamexch99.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'spbook88.com',
            name: 'spbook88',
            dName: 'spbook88',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-spbook.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'maharaja999.in',
            name: 'maharaja999',
            dName: 'maharaja999',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-maharaja999.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'maharaja999.com',
            name: 'maharaja999',
            dName: 'maharaja999',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-maharaja999.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'kapildev365.com',
            name: 'kapildev365',
            dName: 'kapildev365',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-kapildev365.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'mjexch.com',
            name: 'mjexch',
            dName: 'mjexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-mjexch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'win777exch.in',
            name: 'win777exch',
            dName: 'win777exch',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-win777exch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'kingsmakers.io',
            name: 'kingsmakers',
            dName: 'kingsmakers',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-kingsmaker.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'kingsmakers.co',
            name: 'kingsmakers',
            dName: 'kingsmakers',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-kingsmaker.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'redsports999.in',
            name: 'redsports999',
            dName: 'redsports999',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-maharaja999.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'zebraexch7.com',
            name: 'zebraexch7',
            dName: 'zebraexch7',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-zebraexch7.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'pridexexch777.com',
            name: 'pridexexch777',
            dName: 'pridexexch777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-pride.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'whitepawn777.in',
            name: 'whitepawn777',
            dName: 'whitepawn777',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-whitepawn.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'whitepawn777.co',
            name: 'whitepawn777',
            dName: 'whitepawn777',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-whitepawn.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'spexchange.club',
            name: 'spexchange',
            dName: 'spexchange',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'spexchange.co',
            name: 'spexchange',
            dName: 'spexchange',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'noh555.com',
            name: 'noh555',
            dName: 'noh555',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'shyam77.com',
            name: 'shyam77',
            dName: 'shyam77',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-balajionline777.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'dksports555.in',
            name: 'dksports555',
            dName: 'dksports555',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-maharaja999.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'parker777.live',
            name: 'parker777',
            dName: 'parker777',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: '',
                telegram: 'https://t.me/parkerexch_official',
                instagram: 'https://www.instagram.com/parker777.official?igsh=N3V3N2xyaWV0ZmR1',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'parker777.pro',
            name: 'parker777',
            dName: 'parker777',
            ext: '.pro',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: '',
                telegram: 'https://t.me/parkerexch_official',
                instagram: 'https://www.instagram.com/parker777.official?igsh=N3V3N2xyaWV0ZmR1',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'parker777.site',
            name: 'parker777',
            dName: 'parker777',
            ext: '.site',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: '',
                telegram: 'https://t.me/parkerexch_official',
                instagram: 'https://www.instagram.com/parker777.official?igsh=N3V3N2xyaWV0ZmR1',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'v247.co',
            name: 'v247',
            dName: 'v247',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-radhe.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'jj555.co',
            name: 'jj555',
            dName: 'jj555',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-lightblue.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'jj555.io',
            name: 'jj555',
            dName: 'jj555',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-lightblue.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'playwin777.in',
            name: 'playwin777',
            dName: 'playwin777',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'aman555.io',
            name: 'aman555',
            dName: 'aman555',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'blue247.games',
            name: 'blue247',
            dName: 'blue247',
            ext: '.games',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-lightblue.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'taasexch.com',
            name: 'taasexch',
            dName: 'taasexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-radhe.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'taj555.co',
            name: 'taj555',
            dName: 'taj555',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'maharaja555.com',
            name: 'maharaja555',
            dName: 'maharaja555',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'taj333.co',
            name: 'taj333',
            dName: 'taj333',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'pnw777.com',
            name: 'pnw777',
            dName: 'pnw777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'danlaxmi.com',
            name: 'danlaxmi',
            dName: 'danlaxmi',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: 'https://api.whatsapp.com/send/?phone=918735868311&text&type=phone_number&app_absent=0',
                telegram: '',
                instagram: '',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: 'https://api.whatsapp.com/send/?phone=918735868311&text&type=phone_number&app_absent=0',
        },
        {
            domain: 'danlaxmi.co',
            name: 'danlaxmi',
            dName: 'danlaxmi',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: 'https://api.whatsapp.com/send/?phone=918735868311&text&type=phone_number&app_absent=0',
                telegram: '',
                instagram: '',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: 'https://api.whatsapp.com/send/?phone=918735868311&text&type=phone_number&app_absent=0',
        },
        {
            domain: 'anexchange.co',
            name: 'anexchange',
            dName: 'anexchange',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '',
                whatsapp: '',
                telegram: '',
                instagram: '',
            },
            themePath: ['assets/css/theme-files/theme-91blue.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'swastik777.in',
            name: 'swastik777',
            dName: 'swastik777',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '',
                whatsapp: '',
                telegram: '',
                instagram: '',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'swastik777.io',
            name: 'swastik777',
            dName: 'swastik777',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '',
                whatsapp: '',
                telegram: '',
                instagram: '',
            },
            themePath: ['assets/css/theme-files/theme-mahakal9.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'swastik777.co',
            name: 'swastik777',
            dName: 'swastik777',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '',
                whatsapp: '',
                telegram: '',
                instagram: '',
            },
            themePath: ['assets/css/theme-files/theme-mahakal9.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'maruti777.co',
            name: 'maruti777',
            dName: 'maruti777',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: 'https://api.whatsapp.com/send?phone=919205726955&text=Hii%20Maruti777%20%F0%9F%91%8B%0A%0ANeed%20New%20%F0%9F%86%94%20%E2%9C%A8',
                telegram: 'https://t.me/marutionlineb',
                instagram: 'https://www.instagram.com/ma.ruti2489?igsh=djY2OXQ2aW83ZTJq',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'maruti777.io',
            name: 'maruti777',
            dName: 'maruti777',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                facebook: '',
                whatsapp: 'https://api.whatsapp.com/send?phone=919205726955&text=Hii%20Maruti777%20%F0%9F%91%8B%0A%0ANeed%20New%20%F0%9F%86%94%20%E2%9C%A8',
                telegram: 'https://t.me/marutionlineb',
                instagram: 'https://www.instagram.com/ma.ruti2489?igsh=djY2OXQ2aW83ZTJq',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'khelking247.live',
            name: 'khelking247',
            dName: 'khelking247',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '',
                whatsapp: '',
                telegram: '',
                instagram: '',
            },
            themePath: ['assets/css/theme-files/theme-khelking.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'shreenath777.com',
            name: 'shreenath777',
            dName: 'shreenath777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'bigbet99exch.io',
            name: 'bigbet99exch2',
            dName: 'bigbet99exch2',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-bigbet99exch.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: false,
            iframeDomainUrl: '',
            downloadApk: 'https://application-hub.pages.dev/BigBet99Exch.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'alphaplay999.com',
            name: 'alphaplay999',
            dName: 'alphaplay999',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '',
                whatsapp: '',
                telegram: '',
                instagram: '',
            },
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'mycircle777.club',
            name: 'mycircle777',
            dName: 'mycircle777',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-radhe.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: '',
            isAlternateTv: false,
            whatsapp: '',
        },
        {
            domain: 'blue247.io',
            name: 'blue247',
            dName: 'blue247',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                facebook: '#',
                whatsapp: '#',
                telegram: '#',
                instagram: '#',
            },
            themePath: ['assets/css/theme-files/theme-lightblue.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: false,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            downloadApk: 'https://application-hub.pages.dev/Parker777.apk',
            isAlternateTv: false,
            whatsapp: '',
        },
    ]
};

